<template>
  <div class="report-detail-dailog container-block col-block">
    <div class="close-container row-block">
      <div :style="{ flex: 1 }"></div>
      <div class="row-block close-button" :style="{ width: '25px' }">
        <img :src="require('../../assets/images/analysis-close-icon.svg')" @click="e => $emit('changeModal')">
      </div>
    </div>
    <reportDetail
      :reportID="param.data.id"
      :func="param.func"
      :style="{ 'margin-top': '-20px' }"
      @setFilter="tag => setFilter(tag)"
    ></reportDetail>
  </div>
</template>

<script>
import reportDetail from '../report/detail'

export default {
  components: {
    reportDetail
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    setFilter (tag) {
      this.param.func.setFilter(tag.filter)
      this.$emit('changeModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/reportDetail.vue